import { IDataPackage, IProduct } from "../../fetchOrderProducts";

export function isDataPackage(product: IProduct): product is IDataPackage {
  return (
    "specificationId" in product && product.specificationId === "DATA_PACKAGE"
  );
}
